import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface EntityLinkProps {
  name: string;
  href: string;
  iconImagePath: string;
  iconHeightOverride?: number;
  textStyleOverride?: React.CSSProperties;
  iconStyle?: boolean;
  background?: boolean;
}

export function EntityLink(props: EntityLinkProps): JSX.Element {
  const entityLabelElement = props.href
    ? <a href={props.href} style={props.textStyleOverride}>{props.name}</a>
    : <span style={props.textStyleOverride}>{props.name}</span>;

  const iconHeight = props.iconHeightOverride || 17;
  const iconStyle: React.CSSProperties = {
    height: `${iconHeight}px`
  };

    /* eslint-disable jsx-a11y/alt-text */
  if(props.iconStyle){
    return (
    <div className={DetailsTooltipStyles.IconMetadataLinkValue} style={iconStyle}>
      {props.background && <img src={props.iconImagePath} className={DetailsTooltipStyles.cartoucheIconWithBackgroundClass}/>}
      {!props.background && <img src={props.iconImagePath} className={DetailsTooltipStyles.cartoucheIconWithoutBackgroundClass}/>}
      {entityLabelElement}
    </div>
  );}
  else{
    return (
      <div className={DetailsTooltipStyles.MetadataLinkValue} style={iconStyle}>
        <img src={props.iconImagePath} className={DetailsTooltipStyles.ContentTypeIcon}/>
        {entityLabelElement}
      </div>
    );
  }

}
